import { routesAdmin } from "./routesAdmin";
import { routesUser } from "./routesUser";
import { store } from "../../app/store/store";


const filterRoutesByCapabilities = (routes, userCapabilities = []) => {
  return routes.filter(route => {
    // Se la rotta non ha capabilities definite, è accessibile a tutti
    if (!route.capabilities || route.capabilities.length === 0) {
      return true;
    }

    // Verifica se l'utente ha almeno una delle capabilities richieste
    return route.capabilities.some(capability => {
      // Se la capability è vuota o null, accesso consentito
      if (!capability || capability === '') return true;

      // Verifica diretta della capability
      return userCapabilities.includes(capability);
    });
  });
};


export const generateRoutes = (appConfig) => {
  // Ottieni le capabilities dell'utente dal Redux store
  const state = store.getState();
  const userCapabilities = state.app.capabilities || [];

  const identityRole = state.app.role;

  let allRoutes = [];

  if (userCapabilities.length > 0) {
    // Utente con capabilities = utente ADMIN
    allRoutes = routesAdmin(appConfig, identityRole);
  } else {
    // Utente senza capabilities = utente USER
    allRoutes = routesUser(appConfig);
  }
  // Filtra le rotte in base alle capabilities dell'utente
  const filteredRoutes = filterRoutesByCapabilities(allRoutes, userCapabilities);

  // Restituisci le rotte nel formato originale per la sidebar e topbar
  return filteredRoutes
};

export const generateReactRoutes = (appConfig) => {
  const routes = generateRoutes(appConfig);

  // Trasforma le rotte nel formato compatibile con React Router
  return routes.map(route => ({
    path: route.path,
    element: route.component,
  }));
};

export default generateRoutes;